export class InspectorAnswer {
    AnswerId: string;
    QuestionId: string;
    SectionId: string;
    SelectedOptionId: string;
    Remarks: string;
    Stats: InspectorAnswerStats;
    // constructor(data){
    //     this.AnswerId = data.AnswerId || '',
    //     this.QuestionId = data.QuestionId || '',
    //     this.SectionId = data.SectionId || '',
    //     this.SelectedOptionId = data.SelectedOptionId || '',
    //     this.Remarks = data.Remarks || '',
    // }
}

export class InspectorAnswerStats {
    LineCount: number;
}
